import { useEffect, useState } from 'react'

export default function SmallSquareAudioWave({ isPlaying }) {
  const [bars, setBars] = useState([])
  const barCount = 8

  useEffect(() => {
    const initialHeights = Array.from({ length: barCount }, (_, i) => {
      return i % 2 === 0 ? 4 : 2
    })
    setBars(initialHeights)
  }, [])

  function generateRandomHeights(count) {
    return Array.from({ length: count }, () => Math.floor(Math.random() * 8) + 2)
  }

  useEffect(() => {
    let interval

    if (isPlaying) {
      interval = setInterval(() => {
        setBars(generateRandomHeights(barCount))
      }, 100)
    }
    else {
      setBars(Array.from({ length: barCount }, (_, i) => i % 2 === 0 ? 4 : 2))
    }

    return () => clearInterval(interval)
  }, [isPlaying])

  return (
    <div className="flex w-full items-center justify-center">
      <div className="flex items-end gap-x-0.5">
        {bars.map((height, index) => (
          <div
            key={index}
            className="w-0.5 rounded-t transition-all duration-75 ease-in-out"
            style={{
              height: `${height}px`,
              backgroundColor: isPlaying ? '#ffffff' : '#CBD5E1',
              opacity: isPlaying ? 0.7 + (index % 3) * 0.1 : 0.6,
            }}
          />
        ))}
      </div>
    </div>
  )
}
